<div class="h-full flex flex-col items-center justify-center">
  <img src="../../../assets/no-access.png" class="w-[300px]" />
  <div class="text-center text-sm h-36" data-cy="no-license-error">
    <div class="text-lg font-semibold mt-8 mb-2">{{ translations.noAccess.title.text }}</div>
    <div>{{ translations.noAccess.message.text }}</div>
  </div>
</div>
